import { gql, useMutation } from '@apollo/client';
import posthog from 'posthog-js';
import { useIntercom } from 'react-use-intercom';
import { persistor } from 'src/apollo/ApolloClient';
import { revokeSessionUser } from 'src/apollo/sessionInvalidation';
import { clearAdminImpersonating } from 'src/utils/impersonation';

declare global {
  interface Window {
    analytics?: {
      reset: () => void;
    };
    userpilot?: {
      destroy: () => void;
    };
    uetq: Array<any>;
  }
}

export default function useLogout() {
  const { shutdown, boot } = useIntercom();
  const [logout, { client }] = useMutation(LOGOUT, {
    onCompleted: async () => {
      if (process.env.NODE_ENV === 'production') {
        window.analytics?.reset();
        window.userpilot?.destroy();
        if (window.uetq) {
          window.uetq = []; // Clear Bing UET tracking
        }
      }
      revokeSessionUser();
      posthog.reset(); // start the next session replay as a new anonymous visitor
      shutdown(); // shutdown intercom when user logs out
      client.clearStore();
      await persistor.purge();
      window.location.pathname = '/login';
      localStorage.removeItem('episodes-pagination');
      localStorage.removeItem('episodes-filter');
      boot(); // restart intercom in the logged out state
      clearAdminImpersonating();
    },
  });

  return logout;
}

const LOGOUT = gql`
  mutation logout {
    logout
  }
`;
